import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "./services/api";
import HomeView from "./views/HomeView.vue";
import ExamsView from "./views/ExamsView.vue";
import LibraryView from "./views/LibraryView.vue";
import ReaderView from "./views/ReaderView.vue";
import MembershipView from "./views/MembershipView.vue";
import ToolsView from "./views/ToolsView.vue";
import LoginView from "./views/LoginView.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "home", component: HomeView },
    { path: "/exams", name: "exams", component: ExamsView },
    { path: "/library", name: "library", component: LibraryView, meta: { auth: true } },
    { path: "/library/:id", name: "reader", component: ReaderView, meta: { auth: true, immersive: true } },
    { path: "/membership", name: "membership", component: MembershipView, meta: { auth: true } },
    { path: "/tools", name: "tools", component: ToolsView },
    { path: "/login", name: "login", component: LoginView, meta: { bare: true } },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach((to) => {
  if (to.meta.auth && !getToken()) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  if (to.name === "login" && getToken()) return { name: "home" };
  return true;
});

export default router;
